import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

// Protège les sections les plus sensibles (gestion des rôles et des
// permissions elles-mêmes) : accessible uniquement au compte SUPER_ADMIN,
// même un compte ADMIN classique n'y a pas accès.
const AdminRoute = () => {
  const auth = useSelector((state) => state.auth.auth);

  const isAuthenticated = auth?.accessToken;
  const roles = auth?.user?.roles || [];
  const isSuperAdmin = roles.includes("SUPER_ADMIN");

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!isSuperAdmin) {
    return <Navigate to="/page-error-403" replace />;
  }

  return <Outlet />;
};

export default AdminRoute;
